import AppService from '@/services/PricingService.js'
const namespaced = true
const state = {
    lists: [],
    list: {},
    filter_list: "",
    filter_name: "",
    is_no_records: "",
    message: '',
    type: '',
    total_count: '',
    code: '',
    search_criteria: "",
    details: {},
    updated_id: "",
    page: 1,
    show: 10,
    next_record: 0,
    status_code: '',
    status_message: '',
    status_type: '',
    pricelist_index_history: '',
    index_status: ''

}
const mutations = {
    SET_DATAS(state, lists) {
        state.total_count = ''
        state.lists = lists.pricing_list,
            state.search_criteria = lists.search,
            state.filter_list = lists.filter_list,
            state.page = lists.page,
            state.show = lists.show,
            state.next_record = lists.next_record,
            state.filter_name = lists.filter_name,
            state.is_no_records = lists.is_no_records
    },
    LIST_DATA(state, list) {
        state.list = list
        state.error = ''
    },
    LIST_ID(state, updated_id) {
        state.updated_id = updated_id
        state.error = ''
    },
    CANCEL_STATUS(state, data) {
        state.message = data
        state.error = ''
    },
    TOTAL_COUNT(state, data) {
        state.total_count = data.data.total_count
    },
    STATUS_DETAILS(state, data) {
        state.message = data.data.status;
        state.type = data.data.type;
    },
    PRICE_LIST(state, data) {
        state.details = data
    },
    STATUS_CODE(state, code) {
        state.code = code
    },
    SET_CODE(state, data) {
        state.status_code = data.code;
        state.status_message = data.status;
        state.status_type = data.type;
    },

}
const actions = {
    fetchLists({
        commit,
        rootState
    }, {
        page,
        show,
        search,
        status,
        sort,
        label
    }) {

        return AppService.pricinglist.getPricingLists(page, show, search, status, sort, label, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.data.code != 404) {
                    commit("SET_CODE", response.data);
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                } else {
                    commit("SET_CODE", response.data);

                }
                return response;
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    createList({
        commit,
        rootState
    }, data) {

        return AppService.pricinglist.postpricelist(data, rootState.session.token)
            .then(response => {
                commit('STATUS_CODE', response.status)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.status == 201) {
                    commit('CANCEL_STATUS', response.data.data)
                    commit("SET_CODE", response.data);
                } else {
                    commit('LIST_ID', response.data.data)
                    commit("SET_CODE", response.data);
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    updateList({
        commit,
        rootState
    }, {
        id,
        data
    }) {
        return AppService.pricinglist.postupdatepricelist(id, data, rootState.session.token)
            .then(response => {
                commit('STATUS_CODE', response.status)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.status == 201) {
                    commit('CANCEL_STATUS', response.data.data)
                    commit("SET_CODE", response.data);
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data)
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    getProductlist({
        commit,
        rootState
    }, {
        id
    }) {

        return AppService.pricinglist.getproductlist(id, rootState.session.token)
            .then(response => {
                commit('STATUS_CODE', response.status)
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchList({
            commit,
            rootState
        },
        id
    ) {
        return AppService.pricinglist.getpricelist(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_DATA', response.data)
                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchPriceListDetails({
        commit,
        rootState
    }) {
        return AppService.pricinglist.getPriceListDetails(rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('PRICE_LIST', response.data)
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    changeStatus({
            commit,
            rootState
        },
        data
    ) {
        return AppService.pricinglist.statuschange(data, rootState.session.token)
            .then(response => {
                commit("STATUS_DETAILS", response);
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    totalcount({
            commit,
            rootState
        },
        data
    ) {
        return AppService.pricinglist.totalcount(data, rootState.session.token)
            .then(response => {
                commit("SET_CODE", response.data);
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.status == 200) {
                    commit("TOTAL_COUNT", response.data);
                   
                } 
                return response;
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    deletepricelist({
            commit,
            rootState
        },
        data
    ) {
        return AppService.pricinglist.deletepricelist(data, rootState.session.token)
            .then(response => {
                commit("STATUS_DETAILS", response);
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);

                }
                return response;
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    }


}
export default {
    namespaced,
    state,
    mutations,
    actions
}